import React from 'react'
import TwentyFourImage from './img/24-image.png'
import Icon from './img/icon1.svg'
import Icon2 from './img/lb-icon2-red.svg'
import Icon3 from './img/icon-3.svg'
import Icon4 from './img/icon4.svg'
import './content.scss'

export default function EmeraldAboutSection({ data }) {
  return (
    <div className="adwm">
      <div className="adwm__hero"></div>
      <div className="container">
        <div className="adwm__block">
          <div className="adwm__left">
            <h2 className="adwm__title">
              <span>About Dealmed</span> <br /> We move at the speed of light
            </h2>

            <p className="adwm__desc">
              By running ahead on all fronts, we keep you informed and outfitted with a streamlined,
              bulletproof flow of supplies and resources. That’s faster than change itself.
            </p>
          </div>

          <div className="adwm__right">
            <img src={TwentyFourImage} alt="" loading="lazy" />
          </div>
        </div>
      </div>

      <div className="adwm__boxes">
        <div className="adwm__box">
          <div className="adwm__box-icon">
            <img src={Icon} alt="" loading="lazy" />
          </div>

          <p className="adwm__box-text">Our team, on yours</p>
        </div>

        <div className="adwm__box">
          <div className="adwm__box-icon">
            <img src={Icon2} alt="" loading="lazy" />
          </div>

          <p className="adwm__box-text">Logistics delivered</p>
        </div>

        <div className="adwm__box">
          <div className="adwm__box-icon">
            <img src={Icon3} alt="" loading="lazy" />
          </div>

          <p className="adwm__box-text">Working the sources</p>
        </div>

        <div className="adwm__box">
          <div className="adwm__box-icon">
            <img src={Icon4} alt="" loading="lazy" />
          </div>

          <p className="adwm__box-text">Contracting reimagined</p>
        </div>
      </div>
    </div>
  )
}
